import { withAuthenticationRequired } from "@auth0/auth0-react";
import React from "react";
const { PageLoader } = require("./page-loader");

export const ProtectedRoute = ({ component }: any) => {
  const Component = withAuthenticationRequired(component, {
    onRedirecting: () => (
      <div className="page-layout">
        <PageLoader />
      </div>
    ),
  });

  return <Component />;
};
